import Drawer, { CloseDrawer } from './ant';

export default Drawer;
export { CloseDrawer };
